export const MONITORING_EXPORT_KEYS = {
  failed: 'app.reports.monitoring.export.failed',
  rateLimited: 'app.reports.monitoring.export.rateLimited',
} as const;

export const MONITORING_EXPORT_TOO_MANY_REQUESTS = 429;
